// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1129":"ed4d69c1754d8e7b","7697":"0ff690528d406272"}[chunkId] + ".css";
};